import { useState, useEffect, type ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Icon from "@/v2-ui/icon"
import Checkbox from "@/v2-ui/checkbox"
import { useDebouncedValue } from "@/v2-ui/utils/utils.debounce"

export type ManageSearchProps = ComponentProps<"div"> & {
  placeholder?: string
  onSearch(value: string): void
  debounce?: number
  searchAll?: boolean
  onSearchAllChange?(value: boolean): void
}

function ManageSearch(props: ManageSearchProps) {
  const {
    placeholder = "Search...",
    onSearch,
    debounce = 300,
    searchAll,
    onSearchAllChange,
    className,
    ...divProps
  } = props

  const [value, setValue] = useState("")
  const debouncedValue = useDebouncedValue(value, debounce)

  useEffect(() => {
    onSearch(debouncedValue)
  }, [debouncedValue])

  return (
    <div className={cn("manage-search", className)} {...divProps}>
      <Icon src="search" className="manage-search-icon" />
      <input
        className="manage-search-input"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        autoFocus
      />

      {onSearchAllChange && (
        <label className="manage-search-new-only">
          <Checkbox
            size="sm"
            checked={searchAll}
            onCheckedChange={(checked) => {
              onSearchAllChange(checked === true)
            }}
          />
          Search everything
        </label>
      )}
    </div>
  )
}

export default ManageSearch
